var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"reward-container"},[_c('h2',[_vm._v("Claim Your Reward")]),_c('div',[_c('p',[_vm._v(_vm._s(_vm.message))]),(_vm.rewardAvailable)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.claimReward}},[_vm._v(" Claim Now ")]):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }